<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <div
      id="createrecord"
      class="modal fade"
      style="background: rgba(0,0,0,0.5)"
      :class="{ show: show }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="display: flex; justify-content: center"
      >
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <h5
              class="mx-0 px-2 pb-3"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
            {{$t('add_record')}}
            </h5>
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="submitRecord">
              <div class="form-group">
                <label>{{$t('name')}}</label>
                <input
                  type="text"
                  name="name"
                  v-model="name"
                  class="form-control"
                  required
                />
              </div>


              <!-- <div class="form-group">
                <label>Start</label>
                <div class="flex">
                  <input
                    type="date"
                    name="startdate"
                    v-model="startdate"
                    class="form-control"
                    required
                  />
                  <input
                    type="time"
                    name="startime"
                    v-model="startime"
                    class="form-control"
                    required
                  />
                </div>
              </div> -->
              <div v-if="!manualStartRecord" class="form-group">
                <label>{{$t('start')}}</label>
                <div class="flex">
                  <input
                    type="date"
                    name="startdate"
                    v-model="startdate"
                    class="form-control"
                    required
                  />
                  <input
                    type="time"
                    name="starttime"
                    v-model="starttime"
                    class="form-control"
                    required
                  />
                </div>
              </div>
              <p v-if="!manualStartRecord" class="">OR</p>

              <div class="form-group" style="display:flex; align-items:center;">
                <input
                  id="startcheckbox"
                  @change="showStartdate"
                  type="checkbox"
                  checked
                />
                <span class="ml-2">{{$t('start_record')}}</span>
              </div>
              

              <div v-if="!manualEndRecord" class="form-group">
                <label>{{$t('end')}}</label>
                <div class="flex">
                  <input
                    type="date"
                    name="enddate"
                    v-model="enddate"
                    class="form-control"
                    required
                  />
                  <input
                    type="time"
                    name="endtime"
                    v-model="endtime"
                    class="form-control"
                    required
                  />
                </div>
              </div>
              <p v-if="!manualEndRecord" class="">{{$t('or')}}</p>

              <div class="form-group" style="display:flex; align-items:center;">
                <input
                  id="endcheckbox"
                  @change="showEnddate"
                  type="checkbox"
                  checked
                />
                <span class="ml-2">{{$t('end_recording')}}</span>
              </div>


              <div class="form-group">
                <label>{{$t('choose_device')}}</label>
                <select
                  v-model="device"
                  name="device"
                  class="form-control"
                  required
                >
                  <option value="">--{{$t('sel_dev')}}--</option>
                  <option
                    v-for="device in devices"
                    :key="device.deviceTag"
                    :value="device.deviceTag"
                    >{{ device.settings.name }}</option
                  >
                </select>
              </div>
              <div
                class="form-group"
                style="display:flex; justify-content: space-between"
              >
                <button
                  @click="onCancel"
                  type="button"
                  class="btn btn-secondary"
                >
                  {{$t('cancel')}}
                </button>
                <button type="submit" class="btn btn-primary">
                  {{$t('add_record')}}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";

export default {
  name: "CreateRecord",
  components: {
    Loading,
  },
  props: {
    show: Boolean,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      name: "",
      device: "",
      startdate: "",
      starttime: "",
      enddate: "",
      endtime: "",
      manualEndRecord: true,
      manualStartRecord: true,
      mssg: "",
      Errormssg: "",
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  mounted() {
    this.fetchallDevices().then(() => {
      this.isLoading = false;
    });
  },
  computed: {
    ...mapGetters(["devices"]),
  },
  methods: {
    ...mapActions(["fetchallDevices", "addRecord"]),
    onCancel() {
      this.$emit("closeRecordModal");
    },
    showStartdate() {
      let startcheckbox = document.getElementById("startcheckbox");
      if (!startcheckbox.checked) {
        this.manualStartRecord = false;
      } else {
        this.manualStartRecord = true;
        this.startdate = this.starttime = "";
      }
    },
    showEnddate() {
      let endcheckbox = document.getElementById("endcheckbox");
      if (!endcheckbox.checked) {
        this.manualEndRecord = false;
      } else {
        this.manualEndRecord = true;
        this.enddate = this.endtime = "";
      }
    },
    submitRecord() {
      this.isLoading = true;
      this.Errormssg = "";
      let newrecord = {
          name: this.name,
          device: this.device,
        };
      if (this.enddate) {
        newrecord.end = `${this.enddate} ${this.endtime}`;
      }
      if (this.startdate) {
        newrecord.start = `${this.startdate} ${this.starttime}`;
      }

      this.addRecord(newrecord)
        .then((res) => {
          this.isLoading = false;
          this.mssg =
            res.data.message[0].toUpperCase() + res.data.message.slice(1);
          // console.log(res.data);
          setTimeout(() => {
            this.isLoading = true;
          }, 500);
          setTimeout(() => {
            this.$emit("recordCreated", res.data.record);
          }, 2000);
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
  },
};
</script>

<style></style>

<i18n>
{
	"en": {
		"add_record": "Add Record",
		"cancel": "Cancel",
		"choose_device": "Choose Device",
		"end": "End",
		"end_recording": "End the recording manually",
		"name": "Name",
		"or": "Or",
		"sel_dev": "Select Device",
		"start_record": "Start the recording manually"
	},
	"fr": {
		"add_record": "Ajouter un enregistrement",
		"cancel": "annuler",
		"choose_device": "Choisissez l'appareil",
		"end": "Fin",
		"end_recording": "Terminer l'enregistrement manuellement",
		"name": "Prénom",
		"or": "Ou",
		"sel_dev": "Choisir un appareil",
		"start_record": "Démarrer l'enregistrement manuellement"
	},
	"sw": {
		"add_record": "Ongeza Rekodi",
		"cancel": "Ghairi",
		"choose_device": "Chagua Kifaa",
		"end": "Mwisho",
		"end_recording": "Maliza kurekodi mwenyewe",
		"name": "Jina",
		"or": "au",
		"sel_dev": "Chagua Kifaa",
		"start_record": "Anza kurekodi mwenyewe"
	}
}
</i18n>